export default __webpack_public_path__ + "static/media/vento.6d776d45.jpg";